:host {
  display: block;
  text-align: left;
  position: relative;
  z-index: 1;
}
